const transcationData = {
  datesData: {
    a: "",
    b: "",
    c: "Minority stake 5.4%",
    d: "",
    e: "",
    f: "",
    g: "",
    h: "Completed",
    i: "20190104",
    j: "20190104",
    k: "",
    l: "20190104",
    m: "",
    n: "",
    o: "",
    p: "",
    q: "",
    r: "",
    s: "",
    t: ""
  },
  valuesData: {
    a: "2850000000 EUR",
    b: "",
    c: "",
    d: "172880777778",
    e: "52777777778",
    f: "",
    g: "5.4",
    h: "",
    i: "EUR",
    j: "2017/12/31",
  },
  preDealData: {
    a: [113463000, 0.47, "", "", "", ""],
    b: [4008000, 13.17, "", "", 21.43, 13.17],
    c: [1134000, 46.54, "", "", 75.75, 46.54],
    d: [7000000, 7.54, "", "", 12.27, 7.54],
    e: [4982000, 10.59, "", "", 17.24, 10.59],
    f: [1073100000, 0.49, "", "", 0.8, 0.49],
    g: ["", "", "", "", "", ""],
    h: [42092000, 1.25, "", "", 2.04, 1.25],
    i: [48982507, 1.08, "", "", 1.75, 1.08]
  },
  postDealData: {
    a: [373463000, 0.48, "", "", "", ""],
    b: [4448000, 13.11, "", "", 11.43, 13.17],
    c: [112000, 46.54, "", "", 75.75, 46.54],
    d: [7010000, 7.54, "", "", 12.27, 7.54],
    e: [4982000, 10.59, "", "", 17.24, 10.59],
    f: [1072800000, 0.49, "", "", 0.81, 0.49],
    g: ["", "", "", "", "", ""],
    h: [4202000, 1.25, "", "", 2.05, 1.25],
    i: [48982507, 1.08, "", "", 1.17, 1.05]
  },
  futureDealData: {
    a: ["", 172345235, 0.45, "", "", 0.32],
    b: ["", 13563000, 3.81, "", 6.2, 3.81],
    c: ["", 7110000, 7.42, "", 12.08, 7.42],
    d: ["", 4444500, 11.87, "", 19.33, 11.87],
    e: ["", 671124345, 0.81, "", 1.32, 0.83],
    f: ["", "", "", "", "", ""],
  },
  Prices:{
    a: "",
    b: "",
    c: "",
    d: "",
    e: "",
    f: "",
    g: "",
    h: "",
  },
  target:{
    a: "56.31 EUR",
    b: "56.31 EUR",
    c: "45.02 EUR",
    d: "45.02 EUR",
    e: "",
    f: "47.33 EUR",
    g: "49 EUR",
    h: "52.36 EUR",
  },
  acquiror:{
    a: "47.27 EUR",
    b: "47.27 EUR",
    c: "39.68 EUR",
    d: "39.69 EUR",
    e: "",
    f: "41.71 EUR",
    g: "41.71 EUR",
    h: "542.46 EUR",
  },
  vendor:{
    a: "",
    b: "",
    c: "",
    d: "",
    e: "",
    f: "",
    g: "",
    h: "",
  }
}

export default transcationData